var map = {
	".": 46,
	"./": 46,
	"./App": 42,
	"./App.js": 42,
	"./App.test": 124,
	"./App.test.js": 124,
	"./Score": 54,
	"./Score.js": 54,
	"./SetupHoles": 74,
	"./SetupHoles.js": 74,
	"./SetupPlayers": 75,
	"./SetupPlayers.js": 75,
	"./SetupTeams": 76,
	"./SetupTeams.js": 76,
	"./img/hanssoni.png": 442,
	"./img/haussii_ja_nakei.png": 443,
	"./img/hesa-espoo.svg": 114,
	"./img/ike95.png": 444,
	"./img/jallu_pena___vainaja.png": 445,
	"./img/lohja.svg": 112,
	"./img/lumppu.png": 446,
	"./img/lumppu___tenunenu.png": 447,
	"./img/paju.png": 448,
	"./img/pekka_johannes.png": 449,
	"./img/player_2.png": 450,
	"./img/player_3.png": 451,
	"./img/reinikainen.png": 452,
	"./img/tie.svg": 453,
	"./img/tre-kisko.svg": 113,
	"./img/tsaska.png": 454,
	"./index": 46,
	"./index.css": 123,
	"./index.js": 46,
	"./logo.svg": 455,
	"./serviceWorker": 77,
	"./serviceWorker.js": 77,
	"./setupTests": 157,
	"./setupTests.js": 157,
	"./utils": 15,
	"./utils.js": 15
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;